// API設定の型定義
export interface ApiConfig {
  // userToken removed - using Auth0 authentication
  sstfBaseUrl: string;
  webBaseUrl: string;
  graphqlEndpoint: string;
  isEnabled: boolean;
}

// 環境変数からデフォルト設定を取得
const getDefaultConfigFromEnv = (): Partial<ApiConfig> => {
  return {
    sstfBaseUrl: process.env.REACT_APP_SSTF_BASE_URL || "https://bff.dev.sstf.agest.app/api/v2",
    webBaseUrl: process.env.REACT_APP_SSTF_WEB_BASE_URL || "https://dev.sstf.agest.app",
    graphqlEndpoint: process.env.REACT_APP_SSTF_GRAPHQL_ENDPOINT || "https://gql.dev.sstf.agest.app",
    isEnabled: true, // Auth0認証後は常に有効
  };
};

// デフォルト設定
const DEFAULT_CONFIG: Partial<ApiConfig> = getDefaultConfigFromEnv();

// デフォルト設定を取得
export function getDefaultConfig(): ApiConfig {
  return {
    sstfBaseUrl: DEFAULT_CONFIG.sstfBaseUrl!,
    webBaseUrl: DEFAULT_CONFIG.webBaseUrl!,
    graphqlEndpoint: DEFAULT_CONFIG.graphqlEndpoint!,
    isEnabled: DEFAULT_CONFIG.isEnabled!,
  };
}

// 設定の検証
export function validateApiConfig(config: ApiConfig): {
  isValid: boolean;
  errors: string[];
} {
  const errors: string[] = [];

  // userToken validation removed - using Auth0 authentication

  if (!config.sstfBaseUrl) {
    errors.push("SSTF Base URLが設定されていません");
  }

  if (!config.webBaseUrl) {
    errors.push("Web Base URLが設定されていません");
  }

  if (!config.graphqlEndpoint) {
    errors.push("GraphQL Endpointが設定されていません");
  }

  // URL形式の検証
  try {
    new URL(config.sstfBaseUrl);
  } catch {
    errors.push("SSTF Base URLの形式が正しくありません");
  }

  try {
    new URL(config.webBaseUrl);
  } catch {
    errors.push("Web Base URLの形式が正しくありません");
  }

  try {
    new URL(config.graphqlEndpoint);
  } catch {
    errors.push("GraphQL Endpointの形式が正しくありません");
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
}

// 設定の更新
export function updateApiConfig(
  currentConfig: ApiConfig,
  updates: Partial<ApiConfig>
): ApiConfig {
  return {
    ...currentConfig,
    ...updates,
  };
}

// 設定をローカルストレージに保存
export function saveApiConfigToStorage(config: ApiConfig): void {
  try {
    const configToSave = {
      // userToken removed - using Auth0 authentication
      sstfBaseUrl: config.sstfBaseUrl,
      webBaseUrl: config.webBaseUrl,
      graphqlEndpoint: config.graphqlEndpoint,
      isEnabled: config.isEnabled,
    };
    localStorage.setItem("apiConfig", JSON.stringify(configToSave));
  } catch (error) {
    console.error("設定の保存に失敗:", error);
  }
}

// ローカルストレージから設定を読み込み
export function loadApiConfigFromStorage(): Partial<ApiConfig> {
  try {
    const saved = localStorage.getItem("apiConfig");
    if (saved) {
      return JSON.parse(saved);
    }
  } catch (error) {
    console.error("設定の読み込みに失敗:", error);
  }
  return {};
}

// 設定のマージ（ローカルストレージ > デフォルト）
export function mergeApiConfig(): ApiConfig {
  const defaultConfig = getDefaultConfig();
  const storageConfig = loadApiConfigFromStorage();

  const result = {
    ...defaultConfig,
    ...storageConfig,
  } as ApiConfig;

  return result;
}
